export enum PlanType {
    MANDATORY = 'mandatory',
    OPTIONAL = 'optional',
}
